import React, { Children, createContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { trackEvent, trackPageView } from '../../redux/tracking/actions';

export const TrackingContext = createContext();

const TrackingProvider = ({ children }) => {
    const dispatch = useDispatch();
    const trackEventAction = trackData => dispatch(trackEvent(trackData));
    const trackPageViewAction = trackData => dispatch(trackPageView(trackData));

    return (
        <TrackingContext.Provider
            value={{
                trackEvent: trackEventAction,
                trackPageView: trackPageViewAction,
            }}
        >
            {Children.only(children)}
        </TrackingContext.Provider>
    );
};

export default TrackingProvider;

TrackingProvider.propTypes = {
    children: PropTypes.element.isRequired,
};
